import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route, RouterProvider,
} from "react-router-dom";
import {
  LoginPage,
  NotFoundPage,
  SignUpPage,
  EmailSignUpPage,
  SwitchAccountPage,
  OAuthStartPage,
  OAuthEndPage,
  InitSwitchAccountPage,
  OAuthInitPage,
  OAuthDevPage,
  ErrorRedirectPage,
  LogoutPage,
  EmailActionsPage,
  SettingsPage, CaptchaPage, ProviderPreAuthPage, ProviderPostAuthPage, LinkAccountPage, MergeAccountPage,
} from "./pages";
import {AuthProvider} from "./components/auth/AuthContext";
import {FC} from "react";
import {Auth} from "./components/auth/types";
import {initAccount} from "./accounts-api/init-account";
import {PreAuthPage} from "./pages/integrations/PreAuthPage";
import {PostAuthPage} from "./pages/integrations/PostAuthPage";


type Props = {
  auth: Auth
}

export const AccountsApp: FC<Props> = ({auth}) => {
  const router = createBrowserRouter(
      createRoutesFromElements(
          <>
            <Route path="/" element={<Navigate to="/login" replace/>}/>
            <Route path="login">
              <Route path="" element={<LoginPage/>}/>
              <Route path=":provider" element={<ProviderPreAuthPage />}/>
              <Route path=":provider/post-auth" element={<ProviderPostAuthPage/>}/>
            </Route>
            <Route path="integrations">
              <Route path=":app_name/pre-auth" element={<PreAuthPage/>}/>
              <Route path=":app_name/post-auth" element={<PostAuthPage/>}/>
            </Route>

            <Route path="sign-up">
              <Route path="" element={<SignUpPage/>}/>
              <Route path="email" element={<EmailSignUpPage/>}/>
            </Route>
            <Route path="authenticated" element={<Navigate to="/oauth/end"/>}/>
            <Route path="switch">
              <Route path="init" element={<InitSwitchAccountPage/>}/>
              <Route path="" element={<SwitchAccountPage/>}/>
            </Route>
            <Route path="oauth">
              <Route path="init" element={<OAuthInitPage/>}/>
              <Route path="dev" element={<OAuthDevPage/>}/>
              <Route path="start" element={<OAuthStartPage/>}/>
              <Route path="end" element={<OAuthEndPage/>}/>
            </Route>
            <Route path="logout" element={<LogoutPage/>}/>
            <Route path="link-account">
              <Route path="" element={<LinkAccountPage/>}/>
              <Route path="merge" element={<MergeAccountPage/>}/>
            </Route>

            <Route path="settings" element={<SettingsPage/>}/>
            <Route path="email-actions" element={<EmailActionsPage/>}/>
            <Route path="captcha" element={<CaptchaPage/>}/>
            <Route path="error" element={<ErrorRedirectPage/>}/>
            <Route path="/*" element={<NotFoundPage/>}/>
          </>
      )
  )

  return <AuthProvider auth={auth} initAccount={initAccount}>
    <RouterProvider router={router}/>
  </AuthProvider>
};
